import React, { useEffect, useState, } from "react";
import { useTranslation } from "react-i18next";

import Base from '../utils/base'
import moment from "moment";

const Footer = () => {
	var base = new Base()
	const {t, i18n} = useTranslation()

	let momentNow = moment()
	const [phone, setPhone] = useState('')
	const [email, setEmail] = useState('')
	const [address, setAddress] = useState('')
	const [facebook, setFacebook] = useState('')
	const [tiktok, setTiktok] = useState('')
	const [instagram, setInstagram] = useState('')
	const [wa, setWa] = useState('')
	const [homeExclusiveOffer, setHomeExclusiveOffer] = useState({})

	useEffect(() => {
		var lang = window.localStorage.getItem('lang')
		i18n.changeLanguage(lang != null ? lang : 'en')

		get_info_data()
		get_home_exclusive_data()
	}, [])

	async function get_info_data() {
		var response = await base.request(base.url_api + "/setting")

		if(response != null){
			if(response.status == "success"){
				for(let data of response.data){
					if(data.key == 'phone')
						setPhone(data.value)
					else if(data.key == 'address')
						setAddress(data.value)
					else if(data.key == 'email')
						setEmail(data.value)
					else if(data.key == 'facebook')
						setFacebook(data.value)
					else if(data.key == 'tiktok')
						setTiktok(data.value)
					else if(data.key == 'instagram')
						setInstagram(data.value)
					else if(data.key == 'wa_link')
						setWa(data.value)
				}
				
			}
			else
				base.show_error(response.message)
		}
		else
			console.log('Server Error')
	}

	async function get_home_exclusive_data() {
		var response = await base.request(base.url_api + "/info?type=home_exclusive_offer&lang=id")

		if(response != null){
			if(response.status == "success"){
				setHomeExclusiveOffer(response.data)
			}
			else
				base.show_error(response.message)
		}
		else
			console.log('Server Error')
	}

	return (
		<>
			<div class="cta-one cta-one--one wow fadeInUp" data-wow-duration='1500ms' data-wow-delay='200ms'>
        <div class="container">
          <div class="cta-one__inner">
            <div class="cta-one__funfact">
              <div class="cta-one__bg" style={{ backgroundImage: "url(" + homeExclusiveOffer.url_image1 + ")", }}></div>
              <div class="cta-one__funfact__content count-box">
                <h3 class="cta-one__funfact__count" style={{ fontSize: '2.5rem', }}>
                  <span class="cta-one__funfact__count__item count-text" data-stop={homeExclusiveOffer.title != null ? homeExclusiveOffer.title.split('%')[0] : ''} data-speed="1500"></span>
                  <span>%</span>
                </h3>
                <p class="cta-one__funfact__text" style={{ fontSize: '1.5rem', }}>Off</p>
              </div>
            </div>
            <div class="cta-one__content" style={{ backgroundColor: '#5dc9e6', }}>
              <h4 class="cta-one__content__title" style={{ fontSize: '1.875rem', }}>{homeExclusiveOffer.subtitle}</h4>
              <div class="cta-one__content__btn">
                <a href={ window.location.pathname == '/' ? '#' : '/'} class="solinom-btn solinom-btn--base" style={{ fontSize: '1rem', }}>{t('roomIndex.bookNow')}</a>
              </div>
            </div>
          </div>
        </div>
      </div>

			<footer class={"main-footer main-footer-one"} style={{ backgroundColor: '#288AAC', }}>
				<div class="main-footer__top">
					<div class="container">
						<div class="row">
							{/* <div class="col-md-6 col-lg-4 col-xl-5 wow fadeInUp" data-wow-duration='1500ms' data-wow-delay='300ms'>
								<div class="footer-widget footer-widget--about">
									<h2 class="footer-widget__title">About</h2>
									<p class="footer-widget__text">There are many variations passages of Lorem Ipsum available, but the majority have suffered alteration </p>
									<form action="#" data-url="MAILCHIMP_FORM_URL" class="footer-widget__newsletter mc-form">
										<input type="text" name="EMAIL" placeholder="Email Address" />
										<button type="submit" class="fas fa-paper-plane"> <span class="sr-only">submit</span></button>
									</form>
									<div class="mc-form__response"></div>
									<div class="footer-widget__social">
										<a target="_blank" href={facebook}> <i class="fa-brands fa-facebook"></i> <span class="sr-only">Facebook</span></a>
										<a target="_blank" href={wa}> <i class="fa-brands fa-whatsapp"></i> <span class="sr-only">Twitter</span></a>
										<a target="_blank" href={instagram}> <i class="fa-brands fa-instagram"></i> <span class="sr-only">Pinterest</span></a>
										<a target="_blank" href={tiktok}> <i class="fa-brands fa-tiktok"></i> <span class="sr-only">youtube</span></a>
									</div>
								</div>
							</div> */}

							<div class="col-md-6 wow fadeInUp" data-wow-duration='1500ms' data-wow-delay='400ms'>
								<div class="footer-widget footer-widget--links">
									<h2 class="footer-widget__title" style={{ fontSize: '1.2rem', }}>{t('link')}</h2>
									<ul class="list-unstyled footer-widget__links text-white">
										<li><i class="fas fa-circle"></i><a href="/rooms" style={{ fontSize: '1rem', }}>{t('navbar.rooms')}</a></li>
										<li><i class="fas fa-circle"></i><a href="/gallery" style={{ fontSize: '1rem', }}>{t('navbar.gallery')}</a></li>
										{/* <li><i class="fas fa-circle"></i><a href="faq.html">Privacy Policy</a></li>
										<li><i class="fas fa-circle"></i><a href="about.html">About Us</a></li>
										<li><i class="fas fa-circle"></i><a href="contact.html">Contact Us</a></li> */}
									</ul>
								</div>
							</div>
							<div class="col-md-6 wow fadeInUp" data-wow-duration='1500ms' data-wow-delay='700ms'>
								<div class="footer-widget footer-widget--contact">
									<h2 class="footer-widget__title" style={{ fontSize: '1.2rem', }}>{t('contact')}</h2>
									<ul class="list-unstyled footer-widget__info ">
										<li className="">
											<div class="footer-widget__info__item">
												<i class="icon-pin"></i>
											</div>
											<a class="footer-widget__info__text text-white" style={{ flex: 1, fontSize: '1rem', }} target="_blank" href={"https://www.google.com/maps/place/" + (address.replace(' ', '+'))}>{address}</a>
										</li>
										<li>
											<div class="footer-widget__info__item">
												<i class="icon-telephone-call"></i>
											</div>
											<a class="footer-widget__info__text text-white" style={{ flex: 1, fontSize: '1rem', }} target="_blank" href={"tel:" + phone}>{phone}</a>
										</li>
										<li>
											<div class="footer-widget__info__item">
												<i class="icon-envelope"></i>
											</div>
											<a class="footer-widget__info__text text-white" style={{ flex: 1, fontSize: '1rem', }} target="_blank" href={"mailto:" + email}>{email}</a>
										</li>
									</ul>
									{/* <div class="footer-widget__app">
										<a href="https://www.apple.com/app-store/" class="footer-widget__app__item">
											<img src="assets/images/shapes/app-store-1-1.png" alt="app item" />
										</a>
										<a href="https://play.google.com/store/apps?hl=en_US" class="footer-widget__app__item">
											<img src="assets/images/shapes/app-store-1-2.png" alt="app item" />
										</a>
									</div> */}
								</div>
							</div>
						</div>
					</div>
					<div class="main-footer__top__shape">
						<img src="assets/images/shapes/home-footer.png" alt />
					</div>
				</div>
				<div class="main-footer__bottom">
					<div class="container">
						<div class="main-footer__bottom__inner">
							<p class="main-footer__copyright text-white" style={{ fontSize: '1rem', }}>
								&copy; {t('copyright')} {momentNow.format('YYYY')} {t('copyright_by')}
							</p>
						</div>
					</div>
				</div>
			</footer>
		</>
	);
};

export default Footer;
